export default __webpack_public_path__ + "static/media/Globe.b6b76755.svg";